import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {RootState} from '../../store'
import {
  Stack,
  Typography,
  Select,
  MenuItem,
  createTheme,
  ThemeProvider,
  FormControl,
  InputLabel,
  Box,
  Avatar,
} from '@mui/material'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {useDispatch} from 'react-redux'
import i18n from '../../../i18n'
import {actions} from '../../store/vender/Auth/auth.slice'
import {useTranslation} from 'react-i18next'
import Image from '../customTable/Image'

const theme = createTheme({
  components: {
    MuiSelect: {
      styleOverrides: {
        select: {
          '&:before': {
            borderBottom: 'none !important',
            background: 'red',
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          background: 'var(--bs-body-bg)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          background: 'var(--bs-body-bg)',
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          background: 'var(--bs-body-bg)',
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          background: 'var(--bs-body-bg)',
        },
      },
    },
  },
})

export default function SelectLangs({
  option,
  value,
  color,
}: {
  option: any
  value?: any
  color?: string
}) {
  const [selectedOption, setSelectedOption] = useState<any>(value)
  const dispatch = useDispatch()
  useEffect(() => {
    console.log(option,'option');
    
    if (value.id === -1) {
      localStorage.setItem('lang', JSON.stringify(option[0]))

      localStorage.setItem('i18nextLng', JSON.stringify((option[0]&&option[0].code)||'en'))
      dispatch(actions.setLang(option[0].lang))

      dispatch(actions.setRtl(option[0].isRtl))
      setSelectedOption(option[0])

      i18n.changeLanguage(option[0].lang)
    }
  }, [value])
  const handleChange = (event: any) => {
    const selectedId = parseInt(event.target.value)
    const selectedItem = option.find(
      (item: any) => item.id === selectedId || item.value === selectedId
    )
      dispatch(actions.setRtl(selectedItem.isRtl))

    setSelectedOption(selectedItem)
  }
  const {t} = useTranslation()
  return (
    <Stack dir='ltr' position={'relative'}>
      <ThemeProvider theme={theme}>
        <FormControl fullWidth sx={{m: 1, minWidth: 80}}>
          <Select
            labelId='demo-simple-select-label'
            id='demo-simple-select'
            sx={{
              border: '1px solid var(--bs-gray-300)',
              borderRadius: '24px',
              minWidth: '140px',
              color: ' var(--bs-text-dark)',
              width: '100%',

              '& fieldset.MuiOutlinedInput-notchedOutline': {
                border: 'none !important',
              },
              '& .css-ug18ih-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input': {
                padding: '9px 16px !important',
              },
              // borderRadius: '24px',
              '& .css-1k0sxlf': {
                padding: '9px 16px !important',
              },
            }}
            value={selectedOption && (selectedOption.id || selectedOption.value)}
            onChange={handleChange}
          >
            {option.map((e: any) => (
              <MenuItem
                onClick={() => {
                  localStorage.setItem('lang', JSON.stringify(e))
                  dispatch(actions.setLang(e.lang))

                  i18n.changeLanguage(e.lang)
                }}
                sx={{color: ' var(--bs-text-dark)'}}
                key={e.id}
                value={e.id}
              >
                <Stack
                  gap='10px'
                  sx={{'&.css-1auam8d-MuiStack-root': {width: '80%'}}}
                  direction={'row'}
                  alignItems={'center'}
                >
                  <Image className='w-15px h-15px rounded-1 ms-2' alt={e.name} src={e.flag} />
                  <Typography>{t(e.name)}</Typography>
                </Stack>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </ThemeProvider>
    </Stack>
  )
}
